import { render, staticRenderFns } from "./ClinicFilters.vue?vue&type=template&id=6a54ae15&scoped=true&"
import script from "./ClinicFilters.vue?vue&type=script&lang=js&"
export * from "./ClinicFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClinicFilters.vue?vue&type=style&index=0&id=6a54ae15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a54ae15",
  null
  
)

export default component.exports